
export const mapResponseToChartData = (response) => {
  if (!response || typeof response !== "object") {
    return [];
  }

  return Object.keys(response).map((key) => {
    const rawValue = response[key];
    const value = typeof rawValue === "number" && !Number.isNaN(rawValue) ? rawValue : 0;
    return { name: key, value };
  });
};